import React from 'react'
import { connect } from 'react-redux'
import { omit } from 'underscore'
import invariant from 'invariant'
import CSSModules from 'react-css-modules'
import styles from 'CORE_STYLES.scss'

const mapSelectors = (local = [], library = {}) => (state, props) => local.reduce((memo, val) => {
    invariant(library[val], `Could not find selector ${val}. Ensure you have properly exported it`)
    return Object.assign(memo, library[val](state, Object.assign({}, memo, props)))
  }, {})

const mapActions   = (local = {}, library = {}) => (dispatch, { actions = {} }) => {
  return Object.keys(local).reduce((memo, val) => {
    invariant(library[local[val]], `Could not find action ${val}. Ensure you have properly exported it`)
    memo[val] = (...args) => dispatch(library[local[val]].apply(null, args))
    return memo
  }, {})
}

const mergeProps   = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, dispatchProps, stateProps)
}

const AvantI18nDecorator = (Component, passedProps = {}) => {
  class AvantI18nComponent extends React.Component{
    render(){
      return <Component t={this.context.t} {...passedProps} {...this.props}/>
    }
  }
  AvantI18nComponent.contextTypes = {
    t: React.PropTypes.func
  }

  return AvantI18nComponent
}


const applyDecorators = (jsonComponent, context) => {
  const {component = "", props: {selectors = [], actions = {}, components = {}, passedProps = {}} = {}} = jsonComponent
  invariant(context.components[component], `Could not find component ${JSON.stringify(jsonComponent)}`)
  return AvantI18nDecorator(
    connect(
      mapSelectors(selectors, context.selectors),
      mapActions(actions, context.actions),
      mergeProps
    )(
      CSSModules(
        context.components[component],
        styles,
        {handleNotFoundStyleName: "log", allowMultiple: true}
      )
    ),
    passedProps
  )
}

const RenderComponent = (parentProps, context) => {
  const { layout } = parentProps
  if(!layout) return null
    let {
      component,
      props: {
        components = {},
        selectors  = [],
        actions    = {}
      } = {}
    } = layout
  const Elem = applyDecorators(layout, context)
  return <Elem RenderComponent={RenderComponent} {...{
    components: Object.keys(components).reduce((acc, value) => {
      if(Array.isArray(components[value])){
        acc[`${value}`] = components[value].map(elem => (props) => <RenderComponent layout={elem} {...props} RenderComponent={RenderComponent} {...omit(parentProps, ['layout'])} /> )
      }else{
        acc[`${value}`] = (props) => <RenderComponent layout={components[value]} {...props} RenderComponent={RenderComponent} {...omit(parentProps, ['layout'])} />
      }
      return acc
    }, {}),
    ...omit(parentProps, ['layout'])
  }}/>
}

RenderComponent.contextTypes = {
  components: React.PropTypes.object,
  selectors: React.PropTypes.object,
  actions: React.PropTypes.object
}

export default RenderComponent
